export default __webpack_public_path__ + "static/media/parcel-icon2.430cc057.svg";